export class Toaster {
    public type: ToasterType;
    public title: string;
    public message: string;
    public toastLife: number;
}

export enum ToasterType {
    Success,
    Error,
    Info,
    Warning
}
